{
  "responseShape": "伺服器回應與預期格式不符——請重新整理。",
  "badRequest": "請求無效，請檢查您的輸入。",
  "forbidden": "您沒有執行此操作的權限。",
  "facilityRequired": "請在頁首選擇機構以使用此模組。",
  "notFound": "找不到資源。",
  "conflict": "資源已存在。",
  "validation": "驗證錯誤。",
  "tooManyRequests": "請求過於頻繁，請稍後再試。",
  "serverError": "伺服器錯誤，請稍後再試。",
  "unexpected": "發生未預期的錯誤。",
  "network": "網絡錯誤，請檢查您的連線。",
  "requestSetup": "發生錯誤，請重試。",
  "sessionExpired": "您的工作階段已逾時，請重新登入。"
}
